import { render, staticRenderFns } from "./FavoritesPage.vue?vue&type=template&id=9244d56e&scoped=true"
import script from "./FavoritesPage.vue?vue&type=script&lang=js"
export * from "./FavoritesPage.vue?vue&type=script&lang=js"
import style0 from "./FavoritesPage.vue?vue&type=style&index=0&id=9244d56e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9244d56e",
  null
  
)

export default component.exports